export default function KnowledgeReferences({
  metadata,
  concepts = [],
  notes = [],
  insights = [],
  onReferenceClick,
  className = '',
}) {
  const { referencedAssetIds = [], referencedNoteIds = [], referencedInsightIds = [] } = metadata || {};

  if (referencedAssetIds.length === 0 && referencedNoteIds.length === 0 && referencedInsightIds.length === 0) {
    return null;
  }

  return (
    <div className={`space-y-1.5 ${className}`}>
      <div className="text-[9px] font-bold text-gray-500 uppercase tracking-tighter">Referenced Knowledge</div>
      <div className="flex flex-wrap gap-1">
        {referencedAssetIds.map(id => {
          const asset = concepts.find(c => c.id === id);
          if (!asset) return null;
          const isPending = asset.status === 'pending';
          return (
            <button
              key={id}
              onClick={() => onReferenceClick?.('asset', id)}
              className={`text-[9px] border px-1.5 py-0.5 rounded transition-colors cursor-pointer ${
                isPending
                  ? 'bg-amber-950/40 text-amber-300 border-amber-800/30 hover:bg-amber-900/60 hover:border-amber-500/50'
                  : 'bg-emerald-950/40 text-emerald-300 border-emerald-800/30 hover:bg-emerald-900/60 hover:border-emerald-500/50'
              }`}
            >
              Asset: {asset.title}{isPending ? ' (保留)' : ''}
            </button>
          );
        })}
        {referencedNoteIds.map(id => {
          const note = notes.find(n => n.id === id);
          if (!note) return null;
          return (
            <button
              key={id}
              onClick={() => onReferenceClick?.('note', id)}
              className="text-[9px] bg-blue-950/40 text-blue-300 border border-blue-800/30 px-1.5 py-0.5 rounded hover:bg-blue-900/60 hover:border-blue-500/50 transition-colors cursor-pointer"
            >
              Note: {note.title}
            </button>
          );
        })}
        {referencedInsightIds.map(id => {
          const insight = insights.find(i => i.id === id);
          if (!insight) return null;
          if (insight.conceptId && referencedAssetIds.includes(insight.conceptId)) return null;
          return (
            <button
              key={id}
              onClick={() => onReferenceClick?.('insight', id)}
              className="text-[9px] bg-purple-950/40 text-purple-300 border border-purple-800/30 px-1.5 py-0.5 rounded hover:bg-purple-900/60 hover:border-purple-500/50 transition-colors cursor-pointer"
            >
              Hint: {insight.title}
            </button>
          );
        })}
      </div>
    </div>
  );
}
